import React from 'react';
import { Mail, Handshake, CalendarDays, Ticket } from 'lucide-react';
import { CAMPAIGN_TYPES } from '../mock';

const iconMap = { Mail, Handshake, CalendarDays, Ticket };

export default function Campaigns() {
  return (
    <section className="pt-8 pb-16 sm:pt-10 sm:pb-20 lg:pt-14 lg:pb-24 relative" style={{ backgroundColor: '#0f0e1a', color: '#FAFAF9' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="uppercase tracking-[0.16em] text-[11px] sm:text-xs font-semibold mb-3 sm:mb-4" style={{ color: '#10C98F' }}>What we run for you</p>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight max-w-3xl">
          Four focused campaigns. <span className="italic" style={{ color: '#10C98F' }}>All fully managed.</span>
        </h2>
        <p className="mt-4 sm:mt-5 max-w-2xl text-white/75 text-base sm:text-lg">
          Every campaign is written, scheduled, monitored, and improved by AI agents working together. You get results, without touching any software.
        </p>
        <p className="mt-3 text-sm sm:text-base font-semibold" style={{ color: '#10C98F' }}>
          Four campaigns × four channels. Every week, all year.
        </p>

        <div className="mt-10 sm:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CAMPAIGN_TYPES.map((c) => {
            const Icon = iconMap[c.icon];
            return (
              <article key={c.name} className="lift rounded-2xl p-6 border" style={{ backgroundColor: '#1a1638', borderColor: 'rgba(255,255,255,0.08)' }}>
                <span aria-hidden="true" className="inline-flex w-11 h-11 rounded-xl items-center justify-center mb-4" style={{ backgroundColor: 'rgba(107,75,239,0.25)' }}>
                  {Icon && <Icon size={20} style={{ color: '#10C98F' }} />}
                </span>
                <h3 className="font-serif text-2xl">{c.name}</h3>
                <p className="text-sm mt-2 text-white/80 leading-relaxed">{c.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
